// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormHelper[data-v-97752078]{color:var(--colors-gray-500)}\n", ""]);
// Exports
module.exports = exports;
